
    <ngb-toast
      *ngFor="let toast of toastService.toasts"
      [header]="toast.header || ''"
      [autohide]="true"
      [delay]="toast.delay || 9000"
      [class]="toast.classname"
      (hidden)="toastService.remove(toast)"
    >{{ toast.body||"" | translation}}</ngb-toast>